import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'

export const Header = () => {
  const blockId = CMS_BLOCK.HOME_HEADER

  return (
    <Container>
      <CmsBlock
        id={blockId}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <div>
      <div className='header'>
        <h1>Your journey to feeling your best starts right here</h1>
      </div>
    </div>
  )
}
